import { ROUTES } from "@/constants/routes";
import AppStore from "@/icons/app-store.svg";
import FacebookIcon from "@/icons/facebook-filled.svg";
import Instagramicon from "@/icons/instagram-filled.svg";
import LinkdinIcon from "@/icons/linkdin-filled.svg";
import playStore from "@/images/play-store.webp";
import Image from "next/image";
import Link from "next/link";

export function Copyright() {
  return (
    <div className="flex w-full flex-col justify-between gap-10 md:flex-row md:items-center">
      <div className="text-base leading-[150%] tracking-[-0.16px]">© 2024 SkyGo, Inc.</div>
      <div className="flex flex-col gap-10 md:flex-row md:items-center">
        <div className="flex items-center gap-6">
          {/* <Link href={ROUTES.home} title="Linedin">
            <LinkdinIcon />
          </Link>
          <Link href={ROUTES.home} title="Facebook">
            <FacebookIcon />
          </Link> */}
          <Link href={ROUTES.instagram} title="Instagram">
            <Instagramicon />
          </Link>
        </div>
        <div className="flex items-center gap-6">
          <AppStore />
          <Image src={playStore} alt="playStore" className="h-[40px] w-[135px]" />
        </div>
      </div>
    </div>
  );
}
